define('presentation/signup/presentationObjects/signupPaymentMethodPresentationObject',[],function() {
    return function(){
        let self = this;

        self.billingMethod = null;
        self.cardHolderName = null;
        self.expirationDate = null;
        self.addressLineOne = null;
        self.addressLineTwo = null;
        self.city = null;
        self.state = null;
        self.country = null;
        self.postalCode = null;
        self.liveReceptionistPackageId = null;
        self.shouldBypassWelcomeEmail = false;
    };
});
